import React from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
export function App({
  children
}: {
  children?: React.ReactNode;
}) {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">{children}</main>
      <Footer data-id="element-3" />
    </div>;
}